module.exports = __webpack_public_path__ + "img/NCtree4.c5bff2d7.png";